import "./Contact.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ContactHero from "./sections/ContactHero";
import RequestCoastalService from "./sections/RequestCoastalService";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <MainNavigation />
      <ContactHero />
      <RequestCoastalService />
      <Footer />
    </div>;
}